export default __webpack_public_path__ + "static/media/Occult Gem of Strength.dfc11fcd.jpg";